// Dependencies
import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'

// Services
import 'firebase/database'

// Styles
import { ThemeProvider } from 'styled-components'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Theme, GlobalStyle } from './src/styles/global'
import unRegisterWorkers from './src/services/unRegisterWorker'

export const wrapRootElement = ({ element }) => {
  return (
    <Fragment>
      <Helmet>
        <base href="/" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

        <link rel="preload" as="font" href="/fonts/SourceSansPro-Regular.ttf" type="font/ttf" crossOrigin="anonymous" />
        <link rel="preload" as="font" href="/fonts/SourceSansPro-Black.ttf" type="font/ttf" crossOrigin="anonymous" />
      </Helmet>

      <GlobalStyle />

      <ThemeProvider theme={Theme}>
        {element}
      </ThemeProvider>
    </Fragment>
  );
};
unRegisterWorkers()
